// extracted by mini-css-extract-plugin
export default {"logoChild":"Logo_logoChild__-m8E5","logo":"Logo_logo__GOYWr","content":"Logo_content__9Yihu"};